import { API_GET_DOMAINS } from '@/api/apiRoutes'
import api from '@/lib/api'
import { IDnsDomain } from '@/types/DnsDomain'

interface Props {
  ns1?: string
  ns2?: string
  id: string
  selectedNsType: string | null
}

export const changeNsType = async ({ id, ns1, ns2, selectedNsType }: Props) => {
  try {
    const { data } = await api.post<IDnsDomain[]>(
      `${API_GET_DOMAINS}${id}/change_ns_type`,
      { name_server_type: selectedNsType, ns1, ns2 }
    )

    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
